import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { CaseDetailsMessagesContainer } from '../components/case-details-messages.container.tsx';
import { Helmet } from 'react-helmet';

export const MessagesSendReport: React.FC = () => {
  const params = useParams();
  return (
    <>
      <Helmet>
        <title>Case - Messages</title>
      </Helmet>
      <SubPageLayout>
        <CaseDetailsMessagesContainer caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </>
  );
};
